/**
 * searchDirective
 *
 * @author Dec Norton <decnorton@gmail.com>
 */

export function searchDirective() {
    return {
        template: `
            <form autocomplete="off" ng-submit="onSubmit($event)" ng-class="{ showing: showing }">
                <md-input-container md-no-float layout="row" layout-align="center center">
                    <div class="search-field-container" layout="row" layout-align="center center">
                        <input  type="search"
                                class="search-field"
                                name="search"
                                flex-order="1"
                                ng-model="query"
                                placeholder="Search">

                        <md-button class="md-icon-button clear-button" aria-label="Clear search field" title="Open search field" ng-click="clear($event)" ng-show="query.length">
                            <md-icon>clear</md-icon>
                        </md-button>
                    </div>

                    <md-button type="submit"
                               class="md-icon-button search-button"
                               aria-label="Search"
                               title="Search field">
                        <md-icon>search</md-icon>
                        <md-tooltip>Search</md-tooltip>
                    </md-button>
                </md-input-container>
            </form>
        `,
        scope: {
            onClear: '&onClear',
            onSearch: '&onSearch',
            query: '=?query',
            showing: '=?showing',
            searchOnChange: '=?searchOnChange',
        },
        link: function (scope, element) {
            const searchInput = element[0].querySelectorAll('input.search-field')[0];

            if (scope.showing === true) {
                setTimeout(() => {
                    searchInput.focus();
                }, 500);
            }

            scope.clear = clear;
            scope.onSubmit = onSubmit;

            if (scope.searchOnChange === true) {
                let timeout;
                scope.$watch('query', value => {
                    if (value && value.length >= 3) {
                        clearTimeout(timeout);
                        timeout = setTimeout(function() {
                            onSubmit(null);
                        }, 300);
                    }
                });
            }

            /**
             * Clear the input.
             * @param  {MouseEvent} $event
             * @return {void}
             */
            function clear($event) {
                $event.preventDefault();

                scope.query = null;
                scope.showing = false;

                if (angular.isFunction(scope.onClear)) {
                    scope.onClear({
                        $event,
                    });
                }

                if (angular.isFunction(scope.onSearch)) {
                    scope.onSearch({
                        query: null,
                    });
                }
            }

            /**
             * Form submission callback.
             * @param  {Event} $event
             * @return {void}}
             */
            function onSubmit($event) {
                if ($event) {
                    $event.preventDefault();
                }

                if (scope.showing && scope.query && scope.query.length > 0) {
                    scope.onSearch({
                        query: scope.query,
                    });
                } else {
                    scope.showing = !scope.showing;

                    if (scope.showing) {
                        searchInput.focus();
                    } else {
                        clear($event);
                    }
                }
            }
        },
    };
}
